module.exports = __webpack_public_path__ + "static/detail-76d53d1bb05c851be557b4a5921f610d.png";